import { useCallback, useEffect, useState } from "react";
import { EditProfile, ProfileDetails } from "../services/ProfileService";
import { validatePhone, validateRequired } from "../utils/validators";
import { storeUserDetails } from "../utils/auth";

export const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [profileDate, setProfileData] = useState([]);

  const fetchProfileData = useCallback(async () => {
    setLoading(true);
    try {
      const respone = await ProfileDetails();
      setProfileData(respone.get_profile_details[0]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProfileData();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchProfileData]);

  return {
    loading,
    refresh: fetchProfileData,
    profileDate,
  };
};

export const useEditProfile = (id) => {
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [error, setError] = useState("");
  const [hasImageChanged, setHasImageChanged] = useState(false); // Track image changes

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateStep = () => {
    const errors = {};
    const data = profile || {}; // Ensure data exists

    if (!validateRequired(data.first_name || "")) {
      errors.first_name = "First name is required";
    }
    // if (!validateRequired(data.last_name || "")) {
    //   errors.last_name = "Last name is required";
    // }
    // if (!validateEmail(data.email || ""))
    //   errors.email = "Invalid email address";
    if (!validatePhone(data.phone || "")) errors.phone = "Invalid phone number";

    setError(errors);
    return errors;
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setProfile((prev) => ({
          ...prev,
          emp_pic: file,
        }));
        setHasImageChanged(true); // Mark image as changed
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSubmit = async () => {
    const errors = validateStep();

    if (Object.keys(errors).length > 0) {
      setIsLoading(false);
      return;
    }
    try {
      const updateData = { ...profile };

      // Remove emp_pic if image hasn't changed
      if (!hasImageChanged) {
        delete updateData.emp_pic;
      }

      await editProfile(updateData);
      return true; // ✅ success
      //   e.preventDefault();
      // console.log("Updated Profile:", profile);
    } catch (error) {
      return false;
    }

    // Send to backend here if needed
  };
  const editProfile = async (update) => {
    setIsLoading(true);
    try {
      const response = await EditProfile(id, update);
      storeUserDetails(response.data.update_registration.user_details);
    } catch (error) {
      console.log(error.data.emp_pic);
      setError(error.data);

      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    // editProfile,
    isLoading,
    profile,
    setProfile,
    handleImageChange,
    handleInputChange,
    previewImage,
    setPreviewImage,
    handleSubmit,
    error, // Return errors for UI
  };
};
